import { render, staticRenderFns } from "./categoriesDistributionPieCard.vue.html?vue&type=template&id=d14ef8aa&"
import script from "./categoriesDistributionPieCard.ts?vue&type=script&lang=ts&"
export * from "./categoriesDistributionPieCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports